<template>
  <header :class="['header', { 'header--fixed': fixed, 'header--negative': negative }]">
    <sui-grid :columns="3">
      <sui-grid-row>
        <sui-grid-column :computer="3" :mobile="7">
          <router-link to="/">
            <transition-group
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
              mode="out-in"
            >
              <img
                :key="`first-logo`"
                v-show="!secondaryLogo"
                @click="reloadHandler()"
                class="header__logo"
                :class="[{ negative: $route.name !== 'home' }]"
                :src="getLogo"
              />
              <img
                :key="`second-logo`"
                v-show="secondaryLogo"
                @click="reloadHandler()"
                class="header__logo header__logo--secondary"
                :class="[{ negative: $route.name !== 'home' }]"
                :src="secondaryLogo"
              />
            </transition-group>
          </router-link>
        </sui-grid-column>
        <sui-grid-column class="header__menu" :width="8" style="padding-right: 10px;">
          <ul>
            <router-link to="/works">
              <li :class="[{ active: $route.name === 'works' || $route.name === 'work' }]">
                {{ $t("menus.work") }}
              </li>
            </router-link>
            <!-- <router-link to="/news">
              <li :class="[{ active: $route.name === 'news' || $route.name === 'SingleNews' }]">
                {{ $t("menus.news") }}
              </li>
            </router-link> -->
            <router-link to="/about">
              <li :class="[{ active: $route.name === 'AboutUs' }]">{{ $t("menus.about") }}</li>
            </router-link>
            <router-link to="/contact">
              <li :class="[{ active: $route.name === 'Contact' }]">{{ $t("menus.contact") }}</li>
            </router-link>
          </ul>

          <search-icon @click="toggleSearch" v-if="!cleanMode && !negative" />
          <search-icon-white @click="toggleSearch" v-if="!cleanMode && negative" />

          <div class="header__menu__mobile-icon" v-if="!cleanMode" @click="toggleMenuMobile">
            <div class="bar1"></div>
            <div class="bar2"></div>
            <div class="bar3"></div>
          </div>
        </sui-grid-column>
      </sui-grid-row>
    </sui-grid>
  </header>
</template>

<script>
import LogoShortWhite from "@/assets/logo-david-white-sr.png";
import LogoShortBlack from "@/assets/logo-david-short-black.png";
import LogoBlack from "@/assets/logo-david-sr.png";
import SearchSVG from "@/assets/search.svg";
import SearchSVGWhite from "../../assets/search-white.svg";

export default {
  name: "main-header",
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
    negative: {
      type: Boolean,
      default: false,
    },
    cleanMode: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    "search-icon": SearchSVG,
    "search-icon-white": SearchSVGWhite,
  },

  data() {
    return {
      secondaryLogo: null,
    };
  },

  mounted() {
    if (this.$route.name === "home") {
      this.$hub.$on("hideSlider", this.changeLogo);
    }
  },

  computed: {
    getLogo() {
      if (this.$route.name !== "home") {
        return this.negative ? LogoShortWhite : LogoShortBlack;
      }

      return LogoBlack;
    },
  },

  methods: {
    reloadHandler() {
      if (this.$route.name === "home") {
        window.location.reload();
      }
    },

    setLanguage(language) {
      this.$hub.$emit("setLanguage", language);
    },

    toggleSearch() {
      this.$hub.$emit("toggleSearch");
    },

    toggleMenuMobile() {
      this.$hub.$emit("toggleMenuMobile", { negative: this.negative });
    },

    changeLogo() {
      this.secondaryLogo = LogoShortBlack;
    },
  },
};
</script>

<style lang="scss">
@import "./styles/header";
</style>
